import React from 'react';

const ManageRosterContext = React.createContext();

export default ManageRosterContext;
